import React, { useEffect, useState } from "react";
import Sheet from "../ui/Sheet";
import useMediaQuery from "../ui/useMediaQuery";
import useUndoDelete from "../ui/useUndoDelete";
import { plural } from "../ui/text";
import HistoryList, { PAGE } from "./HistoryList";
import UndoToast from "../ui/UndoToast";
import "../ui/tokens.css";
import "./history.css";

// Past chats. A bottom sheet on phones (opens half height, drag to full), a side panel on wide screens.
// Deleting hides the chat at once and offers Undo for five seconds; only then is it deleted for real.
export default function HistoryView({ open, onClose, conversations, loading, currentId, onSelect, onNewChat, onDeleteConversation }) {
  const wide = useMediaQuery("(min-width: 768px)");
  const [query, setQuery] = useState("");
  const [visibleCount, setVisibleCount] = useState(PAGE);
  const undoDelete = useUndoDelete(onDeleteConversation);

  useEffect(() => {
    if (!open) {
      setQuery("");
      setVisibleCount(PAGE);
    }
  }, [open]);

  const { forget } = undoDelete;
  useEffect(() => {
    forget(conversations.map((c) => c.id));
  }, [conversations, forget]);

  useEffect(() => {
    if (!open || !wide) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, wide, onClose]);

  const visible = conversations.filter((c) => !undoDelete.hidden.includes(c.id));

  const header = (
    <div className="hv-header">
      <div>
        <h2 className="hv-title">Your chats</h2>
        <p className="hv-count">{plural(visible.length, "conversation", "conversations")}</p>
      </div>
      <button type="button" className="hv-close" data-sheet-nodrag onClick={onClose}>
        Close
      </button>
    </div>
  );

  const list = (
    <HistoryList
      conversations={visible}
      loading={loading}
      currentId={currentId}
      query={query}
      onQueryChange={(q) => {
        setQuery(q);
        setVisibleCount(PAGE);
      }}
      visibleCount={visibleCount}
      onShowMore={() => setVisibleCount((n) => n + PAGE)}
      onSelect={onSelect}
      onNewChat={onNewChat}
      onDelete={(c) => undoDelete.request(c.id)}
    />
  );

  return (
    <>
      {wide ? (
        open && (
          <aside className="hv-panel" role="dialog" aria-label="Your chats">
            {header}
            <div className="hv-panel-body">{list}</div>
          </aside>
        )
      ) : (
        <Sheet open={open} onClose={onClose} label="Your chats" snaps={[1, 0.5]} initialSnap={1} fill header={header}>
          {list}
        </Sheet>
      )}
      <UndoToast visible={undoDelete.pendingId !== null} label="Chat deleted" onUndo={undoDelete.undo} />
    </>
  );
}
